import React, { useCallback, useRef } from "react";
import LazyLoad from "../lazy-load";
export var Exposure = function (_a) {
  var onExposure = _a.onExposure,
      onece = _a.onece,
      container = _a.container;
  var exposureRef = useRef(null);
  var callback = useCallback(function () {
    var _a;

    var ref = exposureRef.current;
    var repored = (_a = ref === null || ref === void 0 ? void 0 : ref.dataset) === null || _a === void 0 ? void 0 : _a.reported;

    if (onece) {
      if (repored === "false") {
        onExposure && onExposure();
        ref.dataset.reported = "true";
      }
    } else {
      onExposure && onExposure();
    }
  }, [onExposure]);
  return React.createElement("div", {
    "data-reported": false,
    ref: exposureRef
  }, React.createElement(LazyLoad, {
    container: container || null,
    onVisible: function (visible) {
      visible && callback();
    }
  }, React.createElement("div", null)));
};